// extracted by mini-css-extract-plugin
export default {"losange":"skill_losange__PNqkP","los1":"skill_los1__JqUjY","img":"skill_img__McmSp","image":"skill_image__BAzfT","tag":"skill_tag__JZ9NN","start":"skill_start__l0kvR"};